import { REHYDRATE } from 'redux-persist';
import { LOGGED_OUT, REGISTER_USER_SUCCESS, SIGN_IN_SUCCESS, } from 'actions/types';
import { CONNECTING_SECOND_LOGIN, SET_SHOULD_SHOW_FAKE_LOADING_SCREEN, SET_SIGN_IN_SPACE, SKIPPED_PREMIUM_SCREEN, SKIPPED_PREMIUM_SCREEN_SECOND, SKIPPED_PUSH_NOTIFICATIONS, SKIPPED_SECOND_LOGIN, SKIPPED_SET_BUDGETS, REFRESH_CONNECTION_SCREEN_VIEWED, UPGRADED_TO_PREMIUM, SET_SIGN_IN_NAVIGATION_KEY, VIEWED_PREMIUM_WELCOME_SCREEN, SET_CUSTOMIZE_EXPERIENCE_KEY, SET_POSTED_STREAKS_COMMITMENT, SET_DID_SET_HAS_SECOND_LOGIN, SKIPPED_PREMIUM_SCREEN_BEFORE_CHOOSE_BANK, SET_PROFILING_QUESTIONS_KEY, SKIPPED_PREMIUM_WELCOME_GIFT_SCREEN, } from '../actions/types';
export const initialState = {
    premiumScreenSkipped: false,
    premiumScreenWelcomeGiftSkipped: false,
    premiumScreenSkippedSecond: false,
    pushNotificationsSkipped: false,
    refreshConnectionViewed: false,
    secondLoginSkipped: false,
    connectingSecondLogin: false,
    didSetHasSecondLogin: false,
    setupBudgetSkipped: false,
    isSigningIn: false,
    viewedPremiumWelcomeScreen: false,
    hasUpgradedToPremium: false,
    showFakeLoadingScreen: false,
    space: undefined,
    didPostMaritalStatus: false,
    didPostDependantNumber: false,
    didPostEmploymentStatus: false,
    didPostGrossAnnualSalary: false,
    didPostStreaksCommitment: undefined,
    didSeeMyFreeOffer: false,
    didSeeSpendingInsights: false,
    didSeeMyFreeOfferDiscount: false,
    profilingQuestions: undefined,
};
const signInNavigation = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE: {
            if (action.payload?.signInNavigation) {
                return {
                    ...initialState,
                    ...action.payload.signInNavigation,
                    connectingSecondLogin: false,
                    showFakeLoadingScreen: false,
                    refreshConnectionViewed: false,
                };
            }
            return {
                ...state,
                connectingSecondLogin: false,
                showFakeLoadingScreen: false,
                refreshConnectionViewed: false,
            };
        }
        case SET_CUSTOMIZE_EXPERIENCE_KEY: {
            return {
                ...state,
                customizeEmmaExperience: {
                    ...state.customizeEmmaExperience,
                    [action.key]: action.value,
                },
            };
        }
        case SET_PROFILING_QUESTIONS_KEY: {
            return {
                ...state,
                profilingQuestions: {
                    ...state.profilingQuestions,
                    [action.key]: action.value,
                },
            };
        }
        case SET_SHOULD_SHOW_FAKE_LOADING_SCREEN: {
            return {
                ...state,
                showFakeLoadingScreen: action.showFakeLoadingScreen,
            };
        }
        case SKIPPED_PREMIUM_SCREEN_BEFORE_CHOOSE_BANK: {
            return {
                ...state,
                premiumScreenSkippedBeforeChooseBank: true,
            };
        }
        case SKIPPED_PREMIUM_SCREEN: {
            return {
                ...state,
                premiumScreenSkipped: true,
            };
        }
        case SKIPPED_PREMIUM_WELCOME_GIFT_SCREEN: {
            return {
                ...state,
                premiumScreenWelcomeGiftSkipped: true,
            };
        }
        case SKIPPED_PREMIUM_SCREEN_SECOND: {
            return {
                ...state,
                premiumScreenSkippedSecond: true,
            };
        }
        case SKIPPED_PUSH_NOTIFICATIONS: {
            return {
                ...state,
                pushNotificationsSkipped: true,
            };
        }
        case SET_POSTED_STREAKS_COMMITMENT: {
            return {
                ...state,
                didPostStreaksCommitment: true,
            };
        }
        case SKIPPED_SECOND_LOGIN: {
            return {
                ...state,
                secondLoginSkipped: true,
            };
        }
        case REFRESH_CONNECTION_SCREEN_VIEWED: {
            return {
                ...state,
                refreshConnectionViewed: true,
            };
        }
        case SET_DID_SET_HAS_SECOND_LOGIN: {
            return {
                ...state,
                didSetHasSecondLogin: true,
            };
        }
        case CONNECTING_SECOND_LOGIN: {
            return {
                ...state,
                connectingSecondLogin: true,
            };
        }
        case SKIPPED_SET_BUDGETS: {
            return {
                ...state,
                setupBudgetSkipped: true,
            };
        }
        case SIGN_IN_SUCCESS: {
            return {
                ...initialState,
                space: state.space,
                isSigningIn: true,
            };
        }
        case REGISTER_USER_SUCCESS: {
            return {
                ...initialState,
                space: state.space,
                isSigningIn: false,
            };
        }
        case VIEWED_PREMIUM_WELCOME_SCREEN: {
            return {
                ...state,
                viewedPremiumWelcomeScreen: true,
            };
        }
        case UPGRADED_TO_PREMIUM: {
            return {
                ...state,
                hasUpgradedToPremium: true,
            };
        }
        case SET_SIGN_IN_SPACE:
            return {
                ...state,
                space: action.payload,
            };
        case SET_SIGN_IN_NAVIGATION_KEY:
            if (action.key && action.value !== undefined) {
                return {
                    ...state,
                    [action.key]: action.value,
                };
            }
            return state;
        case LOGGED_OUT:
            return initialState;
        default:
            return state;
    }
};
export default signInNavigation;
